<ng-container *ngIf="taskStatusOptions$ | async as taskStatusOptions">
  <ng-container
    *ngIf="
      !isLoading && {
        isTemplateView: isNonPartnerContext$ | async
      } as disablePartnerSpecificOptions
    "
  >
    <span>{{ subtitleKey | translate }}</span>
    <EXP__glxy-wrap>
      <mat-form-field>
        <mat-label>
          {{ 'AUTOMATIONS.EDITOR.TRIGGERS.TASK_STATUS_CHANGED.FILTERS.STATUS' | translate }}
        </mat-label>
        <mat-select [formControl]="taskStatusControl" [required]="!disablePartnerSpecificOptions.isTemplateView">
          <ng-container *ngFor="let taskStatusOption of taskStatusOptions">
            <mat-option [value]="taskStatusOption.value">
              {{ taskStatusOption.label }}
            </mat-option>
          </ng-container>
        </mat-select>
      </mat-form-field>
    </EXP__glxy-wrap>

    <ng-container *ngIf="!disablePartnerSpecificOptions.isTemplateView">
      <p>{{ assigneeFilterDescriptionKey | translate }}</p>

      <mat-form-field appearance="outline" class="search-templates" *ngIf="taskNameOptions$ | async as taskNameOptions">
        <mat-label>{{ nameFilterTitle | translate }}</mat-label>
        <input type="text" [matAutocomplete]="auto" [formControl]="taskNameControl" matInput />
        <mat-icon matSuffix>search</mat-icon>
        <mat-autocomplete #auto>
          <mat-option *ngFor="let taskName of taskNameOptions" [value]="taskName">
            {{ taskName }}
          </mat-option>
        </mat-autocomplete>
      </mat-form-field>
      <automata-automation-replacement-chips
        label="AUTOMATIONS.EDITOR.TRIGGERS.TASK_STATUS_CHANGED.FILTERS.TASK_ASSIGNEE"
        [dataService]="service"
        [formControl]="taskAssigneeFormControl"
        [isRequired]="false"
        [multiple]="false"
        [supportedDataTypes]=""
        [extraData]="true"
      ></automata-automation-replacement-chips>
    </ng-container>
  </ng-container>
</ng-container>

<ng-container *ngIf="isLoading">
  <div class="side-drawer-shimmer-container">
    <span class="title stencil-shimmer"></span>
    <span class="selector stencil-shimmer"></span>
  </div>
</ng-container>
